module.exports = __webpack_public_path__ + "static/pengv2-0e5c2d08eda7cd7cb363cdf3946b698b.png";